
<div style="width: 100%;">
  <div class="container" style="margin: auto;">

    <div *ngIf="!userService.accept" class="animated fadeIn">
      <termsofservice></termsofservice>
    </div>

    <div *ngIf="userService.accept" class="animated fadeIn" style="max-width: 800px; margin: auto; margin-top: 50px; padding: 10px 8px 20px 8px;">


      <div style="border: 1px solid var(--green); text-align: center">

        <div class="row" style="margin: 0">
          <div class="col-md-6" style="padding: 20px 20px 100px 20px">
            <img src="assets/img/icons/login.png" style="margin: 0 auto; height: 100px;" />
            <div style="font-size: 14px; padding: 20px;">
              <span>To register or update your password, we will send an OTP to your cellphone number</span>
            </div>
            <div style="background-color: var(--green); color: #fff; padding: 20px; position: absolute; bottom: 0; left:0; right: 0">
              This is a private network. <br />Unauthorised access is prohibited
            </div>
          </div>
          <div class="col-md-6" style="background-color: rgba(22, 66, 24, 0.1); padding: 20px">

            <div *ngIf="step == 1">

              <mat-form-field class="mt-3">
                <mat-label>Enter your representative number</mat-label>
                <input name="username" matInput [(ngModel)]="repNumber" style="text-transform: none" focus type="number">
                <mat-icon matSuffix style="color: var(--brown)">person</mat-icon>
              </mat-form-field>

              <div class="error m-3 mt-0" *ngIf="error">
                {{ error }}
              </div>

              <button class="button mt-3" (click)="sendOTP()">SEND MY OTP <i class="fas fa-chevron-right"></i></button>
            </div>
            <div *ngIf="step == 2">
              <mat-form-field class="mt-3">
                <mat-label>Enter your OTP Code</mat-label>
                <input name="otp" matInput [(ngModel)]="otpCode" style="text-transform: none" type="number">
                <mat-icon matSuffix style="color: var(--brown)">how_to_reg</mat-icon>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Enter your new password</mat-label>
                <input name="password" maxlength="10" [type]="hide ? 'password' : 'text'" matInput [(ngModel)]="password" style="text-transform: none" />
                <mat-icon matSuffix (click)="hide = !hide" style="cursor: pointer; color: var(--brown)">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                <mat-hint *ngIf="validatePassword()"><div style="float: left; border-radius: 2px; margin-right: 6px; width: 40px; height: 10px; background-color: {{color}}"></div> {{ strength }}</mat-hint>
              </mat-form-field>
              <mat-form-field class="mt-3">
                <mat-label>Confirm your password</mat-label>
                <input name="confirm" maxlength="10" [type]="hide ? 'password' : 'text'" matInput [(ngModel)]="confirm" style="text-transform: none" />
                <mat-hint *ngIf="password && password != confirm">Please ensure that your passwords match</mat-hint>
              </mat-form-field>

              <div class="error" *ngIf="error">
                {{ error }}
              </div>


              <button class="button mt-3" (click)="sendOTP()">REQUEST NEW OTP</button>
              <button *ngIf="showRegister" (click)="register()" class="button mt-1">CONTINUE <i class="fas fa-chevron-right"></i></button>

              <div class="text-muted mt-2 mb-2">
                <small>Your password should have at least 8 characters with one lower case, one uppercase, one numeric and one special character (@$!%*#?&)</small>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>
</div>
